import React from 'react';
import PropTypes from 'prop-types';

import {
  IconButton,
  Popover,
} from '@material-ui/core';

import { makeStyles, useTheme } from '@material-ui/core/styles';

import {
  Warning as WarningIcon,
} from '@material-ui/icons';

import {
  Alert,
} from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
  },
  label: {
  },
  adornment: {
  },
}));

export function ExecutionMessagesIcon(props) {
  const theme = useTheme();
  return (
    <WarningIcon fontSize='small' htmlColor={theme.palette.warning.main} {...props} />
  );
}

export default function ExecutionMessages(props) {

  const { execution } = props;

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    console.log("HANDLE CLOSE!!!!")
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  
  if(!execution) {
    return(null);
  }

  const messages=[];
  if(execution.Message) {
    messages.push(execution.Message);
  }
  if(execution.Tasks && execution.Tasks.LastError) {
    messages.push(`Last Task Error: ${execution.Tasks.LastError}`);
  }
  
  if(messages.length) {
    const id = open ? `em-{execution.ExecutionId}` : undefined;
    return(
      <div className={classes.root}>
        <IconButton size="small" onClick={handleClick}>
          <ExecutionMessagesIcon/>
        </IconButton>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert severity="warning" onClose={handleClose}>
           {messages.join('\n')}
          </Alert>
        </Popover>
      </div>
    );
  } else {
    return(null);
  }
}

ExecutionMessages.propTypes = {
  execution: PropTypes.object,
};

ExecutionMessages.defaultProps = {
};

